import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ORGANIZATIONS_REQUEST,
  fetchOrganizationsFailure,
  fetchOrganizationsSuccess
} from '../actions/organizationAction';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/canopus/organizations`;

const getAuthToken = () => localStorage.getItem('authToken');

function* fetchOrganizationsSaga(action) {
  try {
    const token = getAuthToken();
    const { page = 1, limit = 1, search = '' } = action.payload || {};
    const response = yield call(axios.get, API_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit, search },
    });

    yield put(fetchOrganizationsSuccess(response.data));
  } catch (error) {
    yield put(fetchOrganizationsFailure(error.message));
  }
}

export default function* organizationSaga() {
  yield takeLatest(FETCH_ORGANIZATIONS_REQUEST, fetchOrganizationsSaga);
}
